export default __webpack_public_path__ + "static/media/recharge-block.bd4f6e60.png";